import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/magic.ai/frontend/magicsquare/apps/store-web/components/pages/StoryPage/SpecificStory/AutoLayerStory/AutoLayerStory.tsx");
